<form [formGroup]="formGroup">
  <country-wrapper>
    <ng-template country="NZ">
      <lds-numeric-input
        formControlName="companyNumber"
        name="companyNumber"
        label="Company number"
        placeholder="XXXX-XXX"
        [allowLeadingZeros]="true"
        [isRequired]="isRequired"
        [showHighlight]="showHighlight"
        [minlength]="4"
        [maxlength]="7"
        [validations]="{
          nzcn: 'Must be a valid NZ company number'
        }">
      </lds-numeric-input>
    </ng-template>
    <ng-template countryDefault>
      <lds-numeric-input
        formControlName="companyNumber"
        name="companyNumber"
        label="ACN"
        placeholder="XXX-XXX-XXX"
        [allowLeadingZeros]="true"
        [isRequired]="isRequired"
        [showHighlight]="showHighlight"
        [minlength]="9"
        [maxlength]="11"
        [validations]="{
          acn: 'Must be a valid ACN'
        }">
      </lds-numeric-input>
    </ng-template>
  </country-wrapper>
</form>
